<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Sales payments')"
          :description="$t('From here you can control the sales payments')"
        />
        <indexTable
          :searchText="$t('Find a batch')"
          :emptyTableText="$t('There are no sales payments')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('sales_payments_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Batch'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'client_type',
              title: $t('Customer name'),
              type: 'clintLink',
              sort: true
            },
            {
              column: 'safe_id',
              title: $t('Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('Payment date'),
              type: 'text',
              sort: true
            },
            {
              column: 'invoice_id',
              title: $t('Invoice'),
              type: 'linkInvoice',
              to: 'invoice',
              sort: true,
              link: true
            },
            {
              column: 'description',
              title: $t('Thats about'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('Amount'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('sales_payments_edit')
                },
                { name: 'file' },
                { name: 'printSalesPayment', role: true },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('sales_payments_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/salesPayments'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
